export enum TooltipPosition {
  Before = 'before',
  After = 'after',
  Above = 'above',
  Below = 'below',
  Left = 'left',
  Right = 'right',
}
